export const DEFAULT_ITEMS_PER_PAGE = 20;
export const SMALL_ITEMS_PER_PAGE = 10;
export const LARGE_ITEMS_PER_PAGE = 50;
export const ASC = 'asc';
export const DESC = 'desc';
export const SORT = 'sort';
